import _ from "lodash";

export const incrementsTheEntriesForColorByOne = ({
  data,
  sizesByLength,
  length,
  color,
}) => {
  if (!sizesByLength || !length || !data || !color) return null;
  const colorCode = color.code;

  const dataAfterIncrementation = { ...data };
  if (!dataAfterIncrementation[length]) {
    dataAfterIncrementation[length] = {};
  }
  if (!dataAfterIncrementation[length][colorCode]) {
    dataAfterIncrementation[length][colorCode] = {};
  }

  sizesByLength[length].forEach((s) => {
    if (_.isNil(dataAfterIncrementation[length][colorCode][s])) {
      dataAfterIncrementation[length][colorCode][s] = 0;
    }

    dataAfterIncrementation[length][colorCode][s] += 1;
  });

  return dataAfterIncrementation;
};

export const decrementsTheEntriesForColorByOne = ({
  data,
  sizesByLength,
  length,
  color,
}) => {
  if (!sizesByLength || !length || !data || !color) return null;
  const colorCode = color.code;

  const dataAfterIncrementation = { ...data };
  if (!dataAfterIncrementation[length]) {
    dataAfterIncrementation[length] = {};
  }
  if (!dataAfterIncrementation[length][colorCode]) {
    dataAfterIncrementation[length][colorCode] = {};
  }

  sizesByLength[length].forEach((s) => {
    if (_.isNil(dataAfterIncrementation[length][colorCode][s])) {
      dataAfterIncrementation[length][colorCode][s] = 0;
    }

    dataAfterIncrementation[length][colorCode][s] -= 1;
  });

  return dataAfterIncrementation;
};

export const incrementsTheEntriesForSizeByOne = ({
  data,
  colors,
  length,
  size,
}) => {
  if (!colors || !length || !data || !size) return null;

  const dataAfterIncrementation = { ...data };

  colors.forEach((c) => {
    const colorCode = c.code;
    if (!dataAfterIncrementation[length]) {
      dataAfterIncrementation[length] = {};
    }
    if (!dataAfterIncrementation[length][colorCode]) {
      dataAfterIncrementation[length][colorCode] = {};
    }
    if (!dataAfterIncrementation[length][colorCode][size]) {
      dataAfterIncrementation[length][colorCode][size] = 0;
    }

    if (!_.isNil(dataAfterIncrementation[length][colorCode][size])) {
      dataAfterIncrementation[length][colorCode][size] += 1;
    }
  });

  return dataAfterIncrementation;
};

export const decrementsTheEntriesForSizeByOne = ({
  data,
  colors,
  length,
  size,
}) => {
  if (!colors || !length || !data || !size) return null;

  const dataAfterIncrementation = { ...data };

  colors.forEach((c) => {
    const colorCode = c.code;
    if (!dataAfterIncrementation[length]) {
      dataAfterIncrementation[length] = {};
    }
    if (!dataAfterIncrementation[length][colorCode]) {
      dataAfterIncrementation[length][colorCode] = {};
    }
    if (!dataAfterIncrementation[length][colorCode][size]) {
      dataAfterIncrementation[length][colorCode][size] = 0;
    }

    if (!_.isNil(dataAfterIncrementation[length][colorCode][size])) {
      dataAfterIncrementation[length][colorCode][size] -= 1;
    }
  });

  return dataAfterIncrementation;
};

export const entriesSumForSize = ({ colors, size, length, data }) => {
  if (!colors || !size || !length || !data) return 0;

  return colors.reduce((total, currentColor) => {
    let value = 0;

    if (
      data[length] &&
      data[length][currentColor.code] &&
      data[length][currentColor.code][size]
    ) {
      value = data[length][currentColor.code][size];
    }

    return value + total;
  }, 0);
};

export const entriesSumForColor = ({ sizes, color, length, data }) => {
  if (!sizes || !color || !length || !data) return 0;

  return sizes.reduce((total, currentSize) => {
    let value = 0;
    if (
      data[length] &&
      data[length][color] &&
      data[length][color][currentSize]
    ) {
      value = data[length][color][currentSize];
    }

    return value + total;
  }, 0);
};
